import cn from 'classnames';
import { useComponentInViewport } from 'core-lib/hooks/useComponentInViewport';
import { useEffect, useRef, useState } from 'react';
import useStoreItemClick from 'src/modules/parkplusStoreV2/hooks/useStoreItemClick';
import {
  LayoutEntityType,
  LayoutPropType,
} from 'src/modules/parkplusStoreV2/types/layout';
import { trackSectionViewedStoreV2 } from 'src/modules/parkplusStoreV2/utils/events';
import { Typography } from 'ui-v2/components/Typography';
import VideoListingCard from '../../Cards/VideoListingCard';
import s from './VideoListing.module.scss';

export const VideoListing = ({ data }: LayoutPropType) => {
  const rootRef = useRef();
  const isEventFired = useRef(false);
  const inViewPort = useComponentInViewport(rootRef, {
    threshold: 1,
  });
  const [playedVideo, setPlayedVideo] = useState({ '-1': true });

  const { handleItemClickWithDelegation } = useStoreItemClick();
  const CARDID = data.entityType || 'PRODUCT';
  const handleVideoEnd = (idx) => {
    setPlayedVideo((prev) => ({ ...prev, [idx]: true }));
  };

  useEffect(() => {
    if (inViewPort && !isEventFired.current) {
      trackSectionViewedStoreV2(data?.title);
      isEventFired.current = true;
    }
  }, [data?.title, inViewPort]);

  return (
    <div
      className={s.root}
      ref={rootRef}
      onClick={(e) =>
        handleItemClickWithDelegation(
          e,
          CARDID,
          data?.entityType || LayoutEntityType.Product,
          data?.data,
          data?.title
        )
      }
    >
      <div className={s.header}>
        {data?.title && (
          <Typography
            label={data?.title}
            variant="label_1_bold"
            color="primary"
          />
        )}
        {data?.subtitle && (
          <Typography
            label={data?.subtitle}
            variant="label_3_regular"
            color="tertiary"
          />
        )}
      </div>

      <div className={cn(s.container, 'cmn_hide_scrollbar')}>
        {data?.data?.map((item, index) => (
          <div key={item?.productSku} className={s.item}>
            <VideoListingCard
              key={index}
              playVideoObj={playedVideo}
              title={item?.title}
              subTitle={item?.subtitle1}
              videoUrl={item?.videoUrl}
              icon={item?.coverImage}
              price={item?.price}
              discountedPrice={item?.discountedPrice}
              onVideoEnd={() => {
                handleVideoEnd(index);
              }}
              idx={index}
              id={CARDID}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
